module.exports = __webpack_public_path__ + "01_long_gray.9a8b06a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/01_long_gray.png
// module id = Y9I5
// module chunks = 0